<div class="row">
  <div class="secondary-details col-sm-6 mb-2 mt-2">
    {{ 'maw.mawList.shipmentID' | translate }}
    <ng-container *ngIf="!looseBbx">
      {{ 'maw.mawList.linking' | translate }}
    </ng-container>
  </div>

  <div class="col-sm-6 text-end">
    <button
      class="me-1 icon-mat-header"
      (click)="openTempDialog()"
      #tooltip="matTooltip"
      matTooltip="
       {{ 'maw.mawList.createMawb' | translate }}"
      mat-raised-button>
      <em class="bi bi-plus"></em>
    </button>

    <button
      class="me-1 icon-mat-header"
      (click)="getMawbList()"
      #tooltip="matTooltip"
      matTooltip="
       {{ 'maw.mawList.refresh' | translate }}"
      mat-raised-button>
      <em class="bi bi-arrow-clockwise"></em>
    </button>

    <button
      class="icon-mat-header"
      (click)="applyFilters()"
      #tooltip="matTooltip"
      matTooltip="
       {{ 'maw.mawList.filter' | translate }}"
      mat-raised-button>
      <em class="bi bi-funnel"></em>
    </button>
  </div>
</div>

<ng-template #dialogRef let-mydata>
  <form [formGroup]="countryForm">
    <mat-dialog-content>
      <div class="row h-50">
        <div class="col-12 mt-2" *ngIf="!looseBbx">
          <label class="required-field">
            {{ 'maw.mawList.motherShipperAddress' | translate }}
          </label>
          <select
            class="form-control"
            placeholder="Destination Service Code"
            formControlName="addressId">
            <option
              class="dropdown-option"
              *ngFor="let address of motherShipAddresses"
              [value]="address.addressId">
              {{ address.shipperNickName ? address.shipperNickName : address.shipperCompanyName }}
            </option>
          </select>
          <mat-error
            class="m-2"
            *ngIf="
              countryForm.controls['addressId'].hasError('required') &&
              countryForm.controls['addressId'].pristine &&
              countryForm.controls['addressId'].touched
            ">
            {{ 'maw.mawList.requiredMotherShipperAddress' | translate }}
          </mat-error>
        </div>
        <div class="col-12 mt-2">
          <label class="required-field">
            {{ 'maw.mawList.destinationCountryCode' | translate }}
          </label>
          <select
            class="form-control"
            (change)="countrySelected($event)"
            placeholder="Destination Country Code"
            formControlName="selectedCountry">
            <option class="dropdown-option" *ngFor="let country of countries" [value]="country">
              {{ country }}
            </option>
          </select>
          <mat-error
            class="m-2"
            *ngIf="
              countryForm.controls['selectedCountry'].hasError('required') &&
              countryForm.controls['selectedCountry'].pristine &&
              countryForm.controls['selectedCountry'].touched
            ">
            {{ 'maw.mawList.requiredDestinationCountryCode' | translate }}
          </mat-error>
        </div>
        <div class="col-12 mt-2">
          <label class="required-field">
            {{ 'maw.mawList.destinationServiceCode' | translate }}
          </label>
          <select
            class="form-control"
            placeholder="Destination Service Code"
            formControlName="selectedserviceCountry">
            <option
              class="dropdown-option"
              *ngFor="let country of countryServiceCodes"
              [value]="country">
              {{ country }}
            </option>
          </select>
          <mat-error
            class="m-2"
            *ngIf="
              countryForm.controls['selectedserviceCountry'].hasError('required') &&
              countryForm.controls['selectedserviceCountry'].pristine &&
              countryForm.controls['selectedserviceCountry'].touched
            ">
            {{ 'maw.mawList.requiredDestinationServiceCode' | translate }}
          </mat-error>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button type="submit" class="secondary-btn me-2" (click)="closeDialog()">
        {{ 'maw.mawList.close' | translate }}
      </button>
      <button
        type="submit"
        class="primary-btn me-2"
        [disabled]="!countryForm.valid"
        (click)="createMawb()">
        {{ 'maw.mawList.createMawb' | translate }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>

<div class="row">
  <div class="col-12 no-margin">
    <mat-tab-group
      mat-align-tabs="start"
      [(selectedIndex)]="selectedTabForStatus"
      (selectedTabChange)="onStatusTabChange($event)">
      <mat-tab label="{{ 'maw.mawList.open' | translate }}"></mat-tab>
      <mat-tab label="{{ 'maw.mawList.closed' | translate }}"></mat-tab>
    </mat-tab-group>
  </div>

  <div class="custom-card ms-2 me-2">
    <div class="table-container">
      <table
        mat-table
        aria-describedby="mawlist"
        [dataSource]="dataSource"
        matSort
        matSortActive="createdDateTime"
        matSortDirection="desc">
        <ng-container matColumnDef="MAWB">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'maw.mawList.motherShipmentID' | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            (click)="NavToPalletscreen(element)"
            class="td-link">
            {{ element.MAWB }}
          </td>
        </ng-container>

        <ng-container matColumnDef="motherShipperAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'maw.mawList.motherShipperNickName' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.shipperNickName }}</td>
        </ng-container>

        <ng-container matColumnDef="motherStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'maw.mawList.motherStatus' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.motherStatus }}</td>
        </ng-container>
        <ng-container matColumnDef="noOfPallets">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'maw.mawList.noOfPallets' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element?.noOfPallets }}</td>
        </ng-container>
        <ng-container matColumnDef="totalWeight">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'maw.mawList.totalWeight' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element?.totalWeight }}</td>
        </ng-container>

        <ng-container matColumnDef="createdDateTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'maw.mawList.motherShipmentDateTime' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element?.createdDateTime | date : 'dd/MMM/yyyy hh:mm aa' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="destinationCountry">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'maw.mawList.destinationCountryCode' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.destinationCountry }}</td>
        </ng-container>
        <ng-container matColumnDef="serviceCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'maw.mawList.destinationServiceCode' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.destination_service_code }}
          </td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'maw.mawList.action' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <i
              *ngIf="element.motherStatus === 'Closed'"
              matTooltip="
               {{ 'maw.mawList.printLabel' | translate }}
              "
              class="m-1 icon-mat bi bi-printer"
              (click)="printMaw(element)"></i>

            <i
              matTooltip="{{ 'maw.mawList.printInvoice' | translate }}"
              *ngIf="element.motherStatus === 'Closed' && element?.commercial_invoice_found"
              class="m-1 icon-mat bi bi-receipt-cutoff"
              (click)="printInvoice(element)">
            </i>

            <i
              *ngIf="element.motherStatus !== 'Closed' && configInvoices === 'Custom'"
              matTooltip="
               {{ 'maw.mawList.uploadItemDetails' | translate }}"
              class="m-1 icon-mat bi bi-receipt"
              (click)="openUploadLineItems(element.MAWB)"></i>

            <i
              *ngIf="
                element.motherStatus !== 'Closed' ||
                (element.motherStatus === 'Closed' && element?.commercial_invoice_files_count > 0)
              "
              matTooltip="{{
                element.motherStatus !== 'Closed'
                  ? ('maw.mawList.uploadDocuments' | translate)
                  : ('maw.mawList.viewDocuments' | translate)
              }}"
              class="m-1 icon-mat"
              [ngClass]="{
                'bi bi-clipboard': element.motherStatus === 'Closed',
                'bi bi-file-earmark-arrow-up': element.motherStatus !== 'Closed'
              }"
              (click)="openUploadInvoices(element.MAWB, element.motherStatus)"></i>

            <i
              *ngIf="element.motherStatus !== 'Closed'"
              matTooltip="
               {{ 'maw.mawList.close' | translate }}"
              class="m-1 icon-mat bi bi-folder-x"
              (click)="addDgValues(element)"></i>

            <i
              *ngIf="element.motherStatus !== 'Closed'"
              matTooltip="{{ 'maw.mawList.delete' | translate }}"
              class="m-1 icon-mat bi bi-trash"
              (click)="openDialogAction(element.MAWB, 'delete')"></i>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row justify-content-center" *matNoDataRow>
          {{
            'maw.mawList.noDataAvailable' | translate
          }}
        </tr>
      </table>
      <mat-paginator
        [pageSize]="15"
        [pageSizeOptions]="[5, 10, 15]"
        showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>

<ng-template #dialogdelete>
  <div class="row">
    <div class="col-12">
      <h6 class="text-center">
        {{ 'maw.mawList.deleteMawbLabel' | translate }}
        <br />
      </h6>
    </div>
    <div class="col-2"></div>
    <div class="col-2 btnyes">
      <button class="secondary-btn" (click)="deleteMAWB()">
        {{ 'global.yes' | translate }}
      </button>
    </div>
    <div class="col-1 ml-2">
      <button class="primary-btn" (click)="closeDialog()">
        {{ 'global.cancel' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #dialogfilter>
  <h6>
    {{ 'maw.mawList.advancedFilter' | translate }}
  </h6>
  <form [formGroup]="AdvFilterForm" (submit)="applyAdvFilter()">
    <div class="mb-1">
      <label for="recipient-name" class="col-form-label">
        {{ 'maw.mawList.MAWB' | translate }}
        :</label
      >
      <input type="text" class="form-control" formControlName="mawb" />
    </div>
    <div>
      <label for="recipient-name" class="col-form-label">
        {{ 'maw.mawList.shipmentID' | translate }}:</label
      >
      <input type="text" class="form-control" formControlName="shipmentID" />
    </div>
    <div class="mb-1">
      <label for="recipient-name" class="col-form-label">
        {{ 'maw.mawList.palletIDList' | translate }}
        :</label
      >
      <input type="text" class="form-control" formControlName="palletIDList" />
    </div>
    <div class="mb-1">
      <label for="recipient-name" class="col-form-label">
        {{ 'maw.mawList.status' | translate }}
        :</label
      >
      <select class="form-control" type="text" formControlName="closed">
        <option value="true">{{ 'maw.mawList.closed' | translate }}</option>
        <option value="false">{{ 'maw.mawList.open' | translate }}</option>
      </select>
    </div>
    <div class="mb-1">
      <label for="recipient-name" class="col-form-label">
        {{ 'maw.mawList.destinationCountry' | translate }}
        :</label
      >
      <input type="text" class="form-control" formControlName="destination_country" />
    </div>
    <div class="mb-1">
      <label for="recipient-name" class="col-form-label">
        {{ 'maw.mawList.date' | translate }}
        :</label
      >
      <mat-form-field>
        <mat-label>
          {{ 'maw.mawList.enterDateRange' | translate }}
        </mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input
            type="text"
            matStartDate
            placeholder="{{ 'maw.mawList.startDate' | translate }}"
            formControlName="startDate"
            readonly />
          <input
            type="text"
            matEndDate
            placeholder="{{ 'maw.mawList.endDate' | translate }}"
            formControlName="endDate"
            readonly />
        </mat-date-range-input>
        <mat-hint>
          {{ 'maw.mawList.dateLabel' | translate }}
        </mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
    <button type="submit" [disabled]="isAdvancedFilterCheck()" class="secondary-btn pull-right">
      {{ 'maw.mawList.submit' | translate }}
    </button>
    <button class="primary-btn ml-2" mat-dialog-close="close" (click)="closeDialog()">
      {{ 'global.close' | translate }}
    </button>
  </form>
</ng-template>
